// Helper de solo lectura para mostrar la modalidad de consignación (modelo de negocio)
// del equipo. Reutiliza los valores ya guardados; no cambia cálculos ni acuerdos.
export const MODE_FIXED = "FIXED_OWNER_PRICE";
export const MODE_CP = "COST_PLUS_PROFIT_SHARE";
export const MODE_POST = "POST_SALE_SETTLEMENT";

export const MODE_LABELS = {
  [MODE_FIXED]: "Precio fijo",
  [MODE_CP]: "Capital + reparto",
  [MODE_POST]: "Liquidación posterior",
};

export const modeLabel = (m) => MODE_LABELS[m] || "Precio fijo";

export const modeBlurb = (m) =>
  m === MODE_POST
    ? "Después de vender, se acordará el monto correspondiente al consignador"
    : m === MODE_CP
    ? "El consignador recupera su capital y recibe un % de la ganancia"
    : "El consignador recibe un monto fijo acordado";

// Dueño externo (consignador) = cualquier dueño que no sea PuntoCell (código RR).
export const isExternalOwner = (code) => !!code && code !== "RR";
